<template>
  <InfoPopup :modelValue="modelValue" :title="title" :confirmText="confirmText"
    :cancelText="cancelText" @update:modelValue="$emit('update:modelValue', $event)" @confirm="$emit('confirm')"
    @cancel="$emit('cancel')">
    <div class="info-message" aria-live="polite">
      <p v-if="message">{{ message }}</p>
      <div v-if="reviewSections.length" class="text-review-sections">
        <section v-for="section in reviewSections" :key="section.key" class="text-review-section">
          <p class="text-review-heading">
            <strong>{{ section.title }}</strong>
          </p>
          <p class="text-review-copy">
            <template v-if="section.kind === 'long-lines'">
              <span class="review-metric">{{ section.countText }}</span>
              <span>&nbsp;{{ section.verb }} over the recommended </span>
              <strong>{{ section.limitText }}</strong>
              <span>. Longest line: </span>
              <span class="review-metric">{{ section.longestText }}</span>
              <span>. Long Pro lines may generate unstable audio.</span>
            </template>
            <template v-else-if="section.kind === 'unsupported-characters'">
              <span>Found </span>
              <span class="review-metric">{{ section.countText }}</span>
              <span> across {{ section.lineText }}. These characters can be skipped if you continue.</span>
              <span v-if="section.mostCommon"> Most common: {{ section.mostCommon }}.</span>
            </template>
          </p>
        </section>
      </div>
      <p v-if="summary" class="unsupported-character-summary">{{ summary }}</p>
      <div v-if="details.length" class="unsupported-character-detail-box" tabindex="0"
        aria-label="Unsupported character line and column details">
        <ul class="unsupported-character-detail-list">
          <li v-for="(detail, index) in details" :key="`${index}-${detail}`">{{ detail }}</li>
        </ul>
      </div>
    </div>
  </InfoPopup>
</template>

<script>
import { defineComponent } from 'vue';
import InfoPopup from '@/components/common/InfoPopup.vue';

export default defineComponent({
  name: 'UnsupportedCharacterPopup',
  components: { InfoPopup },
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, default: 'Unsupported Characters Found' },
    message: { type: String, default: '' },
    summary: { type: String, default: '' },
    reviewSections: { type: Array, default: () => [] },
    details: { type: Array, default: () => [] },
    confirmText: { type: String, default: 'Generate without those characters' },
    cancelText: { type: String, default: 'Cancel generation' },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
});
</script>

<style scoped>
.info-message p {
  margin: 0;
}

.unsupported-character-summary {
  margin: 0.65rem 0 0;
  color: var(--text-secondary);
  line-height: 1.45;
}

.text-review-sections {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.text-review-section {
  margin: 0;
}

.text-review-heading {
  margin: 0 0 0.25rem;
  color: var(--text-primary);
  line-height: 1.35;
}

.text-review-copy {
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.45;
}

.review-metric {
  color: #c62828;
  font-weight: 700;
}

.unsupported-character-detail-box {
  margin-top: 0.75rem;
  max-height: calc(1.45em * 5 + 20px);
  overflow-y: auto;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: #f8f8fb;
  padding: 8px 10px;
}

.unsupported-character-detail-list {
  margin: 0;
  padding-left: 1rem;
  color: var(--text-secondary);
  line-height: 1.45;
  font-size: 0.9rem;
  overflow-wrap: anywhere;
}

.unsupported-character-detail-list li {
  margin: 0.25rem 0;
}
</style>
